// src/components/input/InputCliente.js
import React, { useState, useEffect, useId } from 'react';
import { useCliente } from '../../contexts/pessoas/ClienteContext';
import './Input.css';
import { FaPlus, FaSearch } from 'react-icons/fa';
import { useModalForm } from '../modalForm/ModalFormContext';

const InputCliente = ({
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  disabled,
  msgErro,
  style,
  size,
  autoFocus,
  btnBuscar,
  btnAdd
}) => {
  const inputId = useId();
  const { variant } = useModalForm();
  const { clientes } = useCliente();
  const [filteredClientes, setFilteredClientes] = useState([]);
  const [inputValue, setInputValue] = useState(value || '');
  const [isFocused, setIsFocused] = useState(false);

  // Função utilitária para remover acentos e caracteres especiais
  const normalizeString = (str) => {
    return str
      .normalize("NFD") // separa letras de acentos
      .replace(/[\u0300-\u036f]/g, "") // remove os acentos
      .toLowerCase(); // deixa em minúsculo para comparação
  };

  // Update filtered clientes based on input
  useEffect(() => {
  if (inputValue) {
    const search = normalizeString(inputValue);

    const filtered = clientes.filter(cliente =>
      normalizeString(cliente.pessoa.nome).includes(search)
    );

    setFilteredClientes(filtered);
  } else {
    setFilteredClientes(clientes);
  }
}, [inputValue, clientes]);

  // Sync with parent component's value
  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onChange(e); // Propagate to parent component
  };

  const handleSelectCliente = (cliente) => {
    const newValue = cliente.pessoa.nome;
    setInputValue(newValue);
    setIsFocused(false);

    // Update parent form with complete cliente data
    onChange({
      target: {
        value: newValue,
        name: 'nomeCliente',
        dataset: {
          clienteId: cliente.id,
          telefone: cliente.pessoa.telefone?.numero || '',
          endereco: cliente.pessoa.endereco
            ? `${cliente.pessoa.endereco.logradouro}, ${cliente.pessoa.endereco.numero}, ${cliente.pessoa.endereco.bairro}`
            : ''
        }
      }
    });
  };

  return (
    <div className="form-group">
      <label className="form-label" htmlFor={inputId}>{label || '\u00A0'}</label>
      <div className="input-wrapper" style={{ position: 'relative' }}>
        <input
          id={inputId}
          type="text"
          className={`form-control form-input ${msgErro ? 'is-invalid' : ''}`}
          aria-invalid={msgErro ? 'true' : 'false'}
          aria-describedby={msgErro ? `${inputId}-error` : undefined}
          value={inputValue}
          onChange={handleInputChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => {
            setTimeout(() => setIsFocused(false), 200);
            if (onBlur) onBlur();
          }}
          disabled={disabled}
          style={{ ...style, width: size ? `${size}` : '100px' }}
          placeholder={placeholder || 'Digite o nome do cliente'}
          autoFocus={autoFocus}
          data-modal-autofocus={autoFocus || undefined}
          onKeyDown={(event) => {
            if (event.key === 'F2' && btnBuscar) { event.preventDefault(); btnBuscar(event); }
          }}
          list="clientes-list"
        />
        {btnBuscar && (
          <button
            className="btn btn-input"
            style={{ paddingTop: '6px', paddingBottom: '6px', paddingLeft: '6px', paddingRight: '6px' }}
            type="button"
            onClick={btnBuscar}
            tabIndex={variant === 'legacy' ? -1 : 0}
            aria-label={`Buscar ${label || 'cliente'} (F2)`}
          >
            <FaSearch aria-hidden="true" />
          </button>
        )}
        {btnAdd && (
          <button
            className="btn btn-input"
            type="button"
            onClick={btnAdd}
            style={{
              paddingTop: '6px',
              paddingBottom: '6px',
              paddingLeft: '6px',
              paddingRight: '6px',
              marginLeft: '8px'
            }}
            tabIndex={variant === 'legacy' ? -1 : 0}
            aria-label={`Adicionar ${label || 'cliente'}`}
          >
            <FaPlus aria-hidden="true" />
          </button>
        )}
        {isFocused && filteredClientes.length > 0 && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              maxHeight: '200px',
              overflowY: 'auto',
              background: 'white',
              border: '1px solid #ced4da',
              borderRadius: '4px',
              zIndex: 1000,
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
          >
            {filteredClientes.map(cliente => (
              <div
                key={cliente.id}
                style={{
                  padding: '8px 12px',
                  cursor: 'pointer',
                  background: 'white'
                }}
                className="dropdown-item"
                onMouseDown={() => handleSelectCliente(cliente)}
              >
                {cliente.pessoa.nome}
                {cliente.pessoa.endereco && (
                  <small className="d-block text-muted">
                    {`${cliente.pessoa.endereco.logradouro}, ${cliente.pessoa.endereco.numero}, ${cliente.pessoa.endereco.bairro}`}
                  </small>
                )}
                {cliente.pessoa.telefone && (
                  <small className="d-block text-muted">
                    {cliente.pessoa.telefone.numero}
                  </small>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
      {msgErro && <span className="error-input" id={`${inputId}-error`}>{msgErro}</span>}
    </div>
  );
};

export default InputCliente;
